import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import ArticleSection from './components/ArticleSection';
import ProductScroll from './components/ProductScroll';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Kakobuy Spreadsheet Polska – Największa Baza Finds, Linków i List Produktów",
  "description": "Odkrywaj najlepsze produkty, aktualne listy zakupowe oraz sprawdzone arkusze Kakobuy. Sneakersy, streetwear, elektronika i wyjątkowe okazje w jednym miejscu.",
  "url": "https://kakobuyfinds.lat/",
  "inLanguage": "pl",
  "isPartOf": {
    "@type": "WebSite",
    "name": "KakobuyFinds",
    "url": "https://kakobuyfinds.lat"
  },
  "about": {
    "@type": "Organization",
    "name": "KakobuyFinds",
    "url": "https://kakobuyfinds.lat",
    "description": "Największa baza finds i arkuszów zakupowych w Polsce – Kakobuy Spreadsheet, CSSBuy, Superbuy, Oopbuy."
  },
  "primaryImageOfPage": {
    "@type": "ImageObject",
    "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png"
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <CategoryGrid />
        <AboutSection />
        <CTASection />
        <ArticleSection />
        <ProductScroll />
      </main>
      <Footer />
    </>
  );
}